import React from "react";

import CC from "core/ReusableIcons/CC";
import Tooltip from "core/Tooltip";
import { TooltipText } from "./styles";

export default () => (
    <Tooltip
        message={
            <div>
                <TooltipText>
                    This icon is licensed as Creative Commons CCBY
                </TooltipText>
                <TooltipText>
                    When using it for any project, you are required to give
                    credit to the icon's creator or purchase a royalty-free
                    license.
                </TooltipText>
                <a
                    href="https://creativecommons.org/licenses/by/3.0/us/legalcode"
                    target="_blank"
                >
                    Learn more
                </a>
            </div>
        }
    >
        <CC />
    </Tooltip>
);
